export default function CashReport() {
  return (
    <section className="sales-layout__page">
      <h1>Kassenbericht</h1>
      <p>Der Kassenbericht ist in Vorbereitung.</p>
    </section>
  );
}
